<template>
<div class="personCenter">
    <div class="personCenter_content">
        <div class="detailDataTitle">
            <div>订单详情</div>
        </div>
        <div class="flex">
            <div>订单编号</div>
            <div>{{detailData.orderNo || '——'}}</div>
        </div>
        <div class="flex">
            <div>订单内容</div>
            <div>{{detailData.content || '——'}}</div>
        </div>
        <div class="flex">
            <div>订单金额（元）</div>
            <div>{{detailData.price || '——'}}</div>
        </div>
        <div class="flex">
            <div>优惠券（元）</div>
            <div>{{detailData.couponAmount || '——'}}</div>
        </div>
        <div class="flex">
            <div>支付金额（元）</div>
            <div>{{detailData.paidPrice || '——'}}</div>
        </div>
        <div class="flex">
            <div>支付时间</div>
            <div>{{detailData.payTime || '——'}}</div>
        </div>
        <div class="flex">
            <div>支付方式</div>
            <div>{{ detailData.payType && detailData.payType == 10 ? "支付宝" : "微信" }}</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'mOrderRecord',
    components: {},
    data() {
        return {
            detailData: {},
        }
    },
    mounted() {
        this.detailData = this.$route.query.items
        console.log(this.detailData);
    },
    methods:{}
}
</script>

<style scoped>

  .personCenter {
    padding: 0;
    min-height: calc(100vh - 100px);
    background-color: #fff;
  }
  
  .personCenter_content {
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .detailDataTitle {
    box-sizing: border-box;
    padding: 3.4667rem 3.2rem;
    color: #333;
    font-family: PingFang SC;
    font-size: 4.8rem;
    font-weight: 400;
    line-height: 6.1333rem;
  }
  .flex {
    box-sizing: border-box;
    padding: 3.6rem 3.2rem;
    color: #333;
    font-family: PingFang SC;
    font-size: 3.7333rem;
    font-weight: 400;
    line-height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #DDDDDD;
  }
</style>